"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./OptionChainRow.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The OptionChainRow component represents the tabular data for either a "call"
 * or a "put" in the OptionChain component. A complete row in the OptionChain
 * is made up of three cells: One each containing a nested `OptionChainRow` for
 * the "call" and the "put", as well as a cell for the associated strike price.
 */
const OptionChainRow = ({
  ask,
  bid,
  call = false,
  highlight = false,
  selectedType,
  iv,
  ltp,
  onBuy,
  onChart,
  onClick,
  onSell,
  scrollOffset = 0,
  showAsk = true,
  showBid = true,
  showIV = true,
  showLTP = true,
  showOI = true,
  showVolume = true,
  showChart = true,
  oi,
  volume,
  isActionsAvailable = true,
  ...otherProps
}) => {
  const cells = call ? [showOI && {
    key: 'values',
    value: oi
  }, showVolume && {
    key: 'volume',
    value: volume
  }, showIV && {
    key: 'iv',
    value: iv
  }, showBid && {
    key: 'bid',
    value: bid
  }, showAsk && {
    key: 'ask',
    value: ask
  }, showLTP && {
    key: 'ltp',
    value: ltp
  }] : [showLTP && {
    key: 'ltp',
    value: ltp
  }, showAsk && {
    key: 'ask',
    value: ask
  }, showBid && {
    key: 'bid',
    value: bid
  }, showIV && {
    key: 'iv',
    value: iv
  }, showVolume && {
    key: 'volume',
    value: volume
  }, showOI && {
    key: 'values',
    value: oi
  }];
  const direction = call ? 'right' : 'left';
  return (0, _pragma.createFelaElement)(_.TableRow, _extends({
    css: css.row,
    cssProps: {
      highlight,
      selectedType
    },
    onClick: onClick,
    padding: "xsmall"
  }, otherProps), cells.map((cell, i) => {
    if (cell) {
      const {
        key,
        value
      } = cell;
      return value ? (0, _pragma.createFelaElement)(_.TableCell, {
        align: call ? 'left' : 'right',
        css: css.cell,
        cssProps: {
          cellType: key
        },
        padding: [0, 8],
        key: i // eslint-disable-line react/no-array-index-key

      }, value) : undefined;
    }

    return undefined;
  }), isActionsAvailable && (0, _pragma.createFelaElement)(_.View, {
    css: css.actions,
    cssProps: {
      direction,
      highlight
    },
    style: {
      [direction]: scrollOffset
    },
    "data-actions": true
  }, (0, _pragma.createFelaElement)(_.ScripCellTradingActions, {
    showChart: showChart,
    onBuy: selectedType === 'none' ? onBuy : undefined,
    onChart: onChart,
    onSell: selectedType === 'none' ? onSell : undefined
  })));
};

OptionChainRow.displayName = 'OptionChainRow';
var _default = OptionChainRow;
exports.default = _default;
//# sourceMappingURL=OptionChainRow.js.map